import { Box } from '@mui/material';

import { GDMBoxComponent } from './GDMBox.type';

/* TODO: Implement component using GDM default design */
const GDMButton: GDMBoxComponent = props => <Box {...props} />;

export default GDMButton;
